import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Instagram, Plus, Trash2 } from "lucide-react";
import { useAdminApi } from "./useAdminApi";
import { API } from "@/lib/api";

export default function InstagramManager() {
  const api = useAdminApi();
  const [posts, setPosts] = useState([]);
  const [url, setUrl] = useState("");
  const load = () => axios.get(`${API}/instagram`).then((r) => setPosts(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/instagram", { url });
      setUrl("");
      toast.success("Post added to the home page");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not add post");
    }
  };

  const remove = async (p) => {
    await api.del(`/admin/instagram/${p.id}`);
    load();
  };

  return (
    <div className="rounded-2xl bg-[#131B21] border border-white/5 p-5 mb-8" data-testid="instagram-manager">
      <p className="font-display uppercase text-xl flex items-center gap-2 mb-1"><Instagram className="text-[#00C9B7]" size={20} /> Instagram feed on home page</p>
      <p className="text-sm text-slate-400 mb-4">On Instagram, tap ··· on a post → Copy link, then paste it here. The newest 9 show on the home page.</p>
      <form onSubmit={add} className="flex gap-2 mb-4">
        <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://www.instagram.com/p/..." className="flex-1 min-w-0 bg-[#0B0F12] border border-white/10 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#00C9B7]" data-testid="instagram-url-input" />
        <button className="inline-flex items-center gap-1 rounded-xl bg-[#00C9B7] text-[#031312] px-5 text-xs font-bold uppercase tracking-widest" data-testid="instagram-add-btn"><Plus size={14} /> Add</button>
      </form>
      <div className="space-y-2">
        {posts.map((p) => (
          <div key={p.id} className="flex items-center justify-between gap-3 text-sm bg-[#0B0F12] rounded-xl px-4 py-2.5" data-testid={`instagram-admin-item-${p.id}`}>
            <a href={p.url} target="_blank" rel="noreferrer" className="truncate text-slate-300 hover:text-white">{p.url}</a>
            <button onClick={() => remove(p)} className="text-slate-400 hover:text-red-400" data-testid={`instagram-admin-delete-${p.id}`}><Trash2 size={15} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
